import { map } from 'rxjs/operators';

import type { SkillData } from '@sb/feathers-types';
import { mapPaginated } from '@sb/feathers-types';
import type { Unsubscribe } from '@sb/remote-control/types';

import { getSkillsService } from './getSkillsService';

export function onGetAllSkills(
  onSnapshot: (skills: SkillData[]) => void,
): Unsubscribe {
  const subscription = getSkillsService()
    .watch()
    // `paginate: false` returns every skill, not just the first page — routine
    // validation resolves `RunLocateSkill` skillIds against this store, so a
    // skill past page one must not be missing.
    .find({ query: { $sort: { updatedAt: -1 } }, paginate: false })
    .pipe(
      map((response) => {
        const skills = mapPaginated(response, (skill) => skill);
        const seen = new Set<string>();

        return skills.filter((skill) => {
          if (seen.has(skill.id)) {
            return false;
          }

          seen.add(skill.id);

          return true;
        });
      }),
    )
    .subscribe(onSnapshot);

  return () => subscription.unsubscribe();
}
